module.exports = __webpack_public_path__ + "img/36.3682f362.png";